export default [
  require("@assets/sfx/1.mp3"),
  require("@assets/sfx/2.mp3"),
  require("@assets/sfx/3.mp3"),
  require("@assets/sfx/4.mp3"),
  require("@assets/sfx/5.mp3"),
  require("@assets/sfx/6.mp3"),
  require("@assets/sfx/7.mp3"),
  require("@assets/sfx/8.mp3"),
  require("@assets/sfx/9.mp3"),
  require("@assets/sfx/10.mp3"),
  require("@assets/sfx/11.mp3"),
];
